import { render } from "./ViewerWidgets.vue?vue&type=template&id=7b6a1e20"
import script from "./ViewerWidgets.vue?vue&type=script&lang=js"
export * from "./ViewerWidgets.vue?vue&type=script&lang=js"

import "./ViewerWidgets.vue?vue&type=style&index=0&id=7b6a1e20&lang=css"

import exportComponent from "/home/runner/work/webapp/webapp/main/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__